import { create } from 'zustand';
import { Moment } from 'moment/moment';

import { ESortOrder, EStatusStr } from '@src/emp-3.0/types';
import { createSetState } from '@src/emp-3.0/utils/management';

interface IUseBlockVideoEventsManagementStoreProps {
  unblockSelectedList: string[];
  setUnblockSelectedList: (unblockSelectedList: string[]) => void;
  // search
  searchText: string;
  setSearchText: (searchText: string) => void;
  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;
  // filter condition
  showFilter: boolean;
  setShowFilter: (hiddenFilter: boolean) => void;
  blockedBy: string;
  setBlockedBy: (blockedBy: string) => void;
  blockedDate: Moment[];
  setBlockedDate: (blockedDate: Moment[]) => void;
  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useBlockVideoEventsManagementStore = create<IUseBlockVideoEventsManagementStoreProps>(
  (set) => ({
    unblockSelectedList: [],
    searchText: '',
    sort: { key: '', order: ESortOrder.NORMAL },

    setUnblockSelectedList: createSetState(set, 'unblockSelectedList'),
    setSearchText: createSetState(set, 'searchText'),
    setSort: createSetState(set, 'sort'),

    // filter condition
    showFilter: false,
    status: EStatusStr.ALL,
    blockedDate: [],
    blockedBy: 'All',

    setShowFilter: createSetState(set, 'showFilter'),
    setStatus: createSetState(set, 'status'),
    setBlockedDate: createSetState(set, 'blockedDate'),
    setBlockedBy: createSetState(set, 'blockedBy'),

    // reset
    resetFilter: () =>
      set(() => ({
        status: EStatusStr.ALL,
        blockedDate: [],
        blockedBy: 'All',
      })),

    resetStore: () =>
      set(() => ({
        unblockSelectedList: [],
        searchText: '',
        sort: { key: '', order: ESortOrder.NORMAL },
        showFilter: false,
        status: EStatusStr.ALL,
        blockedDate: [],
        blockedBy: 'All',
      })),
  }),
);
